import { h } from 'preact';
import PureComponent from './PureComponent';

import IconButton from 'preact-material-components/IconButton';
import 'preact-material-components/IconButton/style.css';

import style from './AppBar.css';

type Props = {
  className: string,
  onLogoutSuccess: () => void
};

const ExitIcon = () => (
  <svg className={style.icon} viewBox="0 0 24 24">
    <g id="Header_x2F_BG" display="none">
      <rect
        x="-50"
        y="-358"
        display="inline"
        fill="#F1F1F2"
        width="520"
        height="520"
      />
    </g>
    <g id="Bounding_Boxes">
      <g id="ui_x5F_spec_x5F_header_copy_3" />
      <path fill="none" d="M0,0h24v24H0V0z" />
    </g>
    <g id="Rounded">
      <g id="ui_x5F_spec_x5F_header_copy_5" />
      <path
        d="M10.79,16.29L10.79,16.29c0.39,0.39,1.02,0.39,1.41,0l3.59-3.59c0.39-0.39,0.39-1.02,0-1.41l-3.59-3.59
		c-0.39-0.39-1.02-0.39-1.41,0l0,0c-0.39,0.39-0.39,1.02,0,1.41L12.67,11H4c-0.55,0-1,0.45-1,1v0c0,0.55,0.45,1,1,1h8.67l-1.88,1.88
		C10.4,15.27,10.41,15.91,10.79,16.29z M19,3H5C3.89,3,3,3.9,3,5v3c0,0.55,0.45,1,1,1h0c0.55,0,1-0.45,1-1V6c0-0.55,0.45-1,1-1h12
		c0.55,0,1,0.45,1,1v12c0,0.55-0.45,1-1,1H6c-0.55,0-1-0.45-1-1v-2c0-0.55-0.45-1-1-1h0c-0.55,0-1,0.45-1,1v3c0,1.1,0.9,2,2,2h14
		c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z"
      />
    </g>
    <g id="Sharp" display="none">
      <g id="ui_x5F_spec_x5F_header_copy_4" display="inline" />
      <path
        display="inline"
        d="M10.09,15.59L11.5,17l5-5l-5-5l-1.41,1.41L12.67,11H3v2h9.67L10.09,15.59z M21,3H3v6h2V5h14v14H5v-4H3v6
		h18V3z"
      />
    </g>
    <g id="Outline" display="none">
      <g id="ui_x5F_spec_x5F_header" display="inline" />
      <path
        display="inline"
        d="M10.09,15.59L11.5,17l5-5l-5-5l-1.41,1.41L12.67,11H3v2h9.67L10.09,15.59z M19,3H5C3.89,3,3,3.9,3,5v4h2
		V5h14v14H5v-4H3v4c0,1.1,0.89,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z"
      />
    </g>
    <g id="Duotone" display="none">
      <g id="ui_x5F_spec_x5F_header_copy_2" display="inline" />
      <g display="inline">
        <path
          d="M10.09,15.59L11.5,17l5-5l-5-5l-1.41,1.41L12.67,11H3v2h9.67L10.09,15.59z M19,3H5C3.89,3,3,3.9,3,5v4h2V5h14v14H5v-4H3v4
			c0,1.1,0.89,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z"
        />
      </g>
    </g>
    <g id="Fill" display="none">
      <g id="ui_x5F_spec_x5F_header_copy" display="inline" />
      <path
        display="inline"
        d="M10.09,15.59L11.5,17l5-5l-5-5l-1.41,1.41L12.67,11H3v2h9.67L10.09,15.59z M19,3H5C3.89,3,3,3.9,3,5v4h2
		V5h14v14H5v-4H3v4c0,1.1,0.89,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z"
      />
    </g>
    <g id="nyt_x5F_exporter_x5F_info" display="none" />
  </svg>
);

class GoogleLogout extends PureComponent<Props> {
  constructor(props) {
    super(props);
    this.state = {
      disabled: true
    };
  }
  componentDidMount() {
    ((d, s, id, cb) => {
      const element = d.getElementsByTagName(s)[0];
      const fjs = element;
      let js = element;
      js = d.createElement(s);
      js.id = id;
      js.src = '//apis.google.com/js/client:platform.js';
      fjs.parentNode.insertBefore(js, fjs);
      js.onload = cb;
    })(document, 'script', 'google-login', () => {
      window.gapi.load('auth2', () => {
        this.setState({
          disabled: false
        });
      });
    });
  }

  signOut = () => {
    const auth2 = window.gapi.auth2.getAuthInstance();
    if (auth2 != null) {
      auth2.signOut().then(this.props.onLogoutSuccess);
    }
  };

  render() {
    return (
      <IconButton className={this.props.className} onClick={this.signOut}>
        <ExitIcon />
      </IconButton>
    );
  }
}

export default GoogleLogout;



// WEBPACK FOOTER //
// ./components/GoogleLogout.js